import { Injectable } from '@angular/core';
import { AdditionalWorkRequestModel } from '../business-entities/additional-work-report.model';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';

@Injectable({
  providedIn: 'root'
})
export class AdditionalWorkReportDataService {

  constructor(private dataService: DataService) { }

  async getAdditionalWorkList(requestModel: AdditionalWorkRequestModel): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.GetAdditionalWorkList, requestModel).toPromise();
  }

}